import React, { useEffect, useState, useRef } from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import About from './About';
import Skills from './Skills';
import Experience from './Experience';
import Projects from './Projects';
import Certifications from './Certifications';
import Achievements from './Achievements';
import Contact from './Contact';
import Footer from './Footer';

const Portfolio = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [progress, setProgress] = useState(0);

  // Reveal-on-scroll observer
  useEffect(() => {
    const els = document.querySelectorAll('.reveal');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  // Custom cursor
  useEffect(() => {
    const dot = dotRef.current;
    const ring = ringRef.current;
    if (!dot || !ring) return;
    let mouseX = 0, mouseY = 0, ringX = 0, ringY = 0;
    const handleMove = (e) => {
      mouseX = e.clientX; mouseY = e.clientY;
      dot.style.transform = `translate(${mouseX - 4}px, ${mouseY - 4}px)`;
    };
    // Respect reduced-motion / touch devices — skip the custom cursor entirely
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const noHover = window.matchMedia('(hover: none)').matches;
    if (reduce || noHover) return;

    let rafId;
    const animate = () => {
      ringX += (mouseX - ringX) * 0.18;
      ringY += (mouseY - ringY) * 0.18;
      ring.style.transform = `translate(${ringX - 18}px, ${ringY - 18}px)`;
      rafId = requestAnimationFrame(animate);
    };
    window.addEventListener('mousemove', handleMove);
    rafId = requestAnimationFrame(animate);

    // Event delegation — works for dynamically rendered elements (filtered cards, mobile menu)
    const over = (e) => { if (e.target.closest('a, button, .hover-cursor')) document.body.classList.add('cursor-hover'); };
    const out = (e) => { if (e.target.closest('a, button, .hover-cursor')) document.body.classList.remove('cursor-hover'); };
    document.addEventListener('mouseover', over);
    document.addEventListener('mouseout', out);

    return () => {
      window.removeEventListener('mousemove', handleMove);
      document.removeEventListener('mouseover', over);
      document.removeEventListener('mouseout', out);
      cancelAnimationFrame(rafId);
    };
  }, []);

  // Scroll progress (rAF-throttled to avoid layout thrash)
  useEffect(() => {
    let ticking = false;
    const handler = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const total = document.documentElement.scrollHeight - window.innerHeight;
        setProgress(total > 0 ? (window.scrollY / total) * 100 : 0);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <>
      <div ref={dotRef} className="cursor-dot" />
      <div ref={ringRef} className="cursor-ring" />
      <div
        className="fixed top-0 left-0 h-[2px] z-[300] transition-[width] duration-100"
        style={{ width: `${progress}%`, background: 'linear-gradient(90deg,#d97757,#f4a261)' }}
      />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Skills />
        <Experience />
        <Projects />
        <Certifications />
        <Achievements />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default Portfolio;
